import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Step, StepButton, Stepper as MuiStepper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  activeButton: {
    '& .MuiStepLabel-iconContainer': {
      color: '#fff',
      borderColor: theme.palette.primary.hover,
      backgroundColor: theme.palette.primary.hover,
    }
  }
}));

export const Stepper = (props) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  return (
    <div className={classes.root}>

      <MuiStepper nonLinear alternativeLabel activeStep={activeStep}>
        {props.steps.map((step, index) => (
          <Step key={step.label}>
            <StepButton 
              disableRipple
              icon={step.icon} 
              onClick={handleStep(index)} 
              className={index === activeStep ? classes.activeButton : ''}
            >
              {step.label}
            </StepButton>
          </Step>
        ))}
      </MuiStepper>


      {props.steps.map((step, index) => (
        <div key={index} style={{display: activeStep === index ? 'block' : 'none'}}> 
          {step.content}
        </div>
      ))}
      {/* <div>
        <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
      </div> */}
      
    </div>
  );
}